module.exports = __webpack_public_path__ + "static/52invgde-76ca97c83748262ead1a06633cae9272.gif";